/**
 * @license
 * Copyright 2019 Xunlei Network.
 *
 * @description
 * Tbc native api delegate.
 */
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XLMacNativeApi = exports.XLMacNativeCore = void 0;
var sdk_1 = require("@xbase/sdk");
var utils_1 = require("./common/utils");
var interface_1 = require("./interface");
/**
 * XL mac native core.
 */
var XLMacNativeCore = /** @class */ (function () {
    function XLMacNativeCore() {
    }
    Object.defineProperty(XLMacNativeCore.prototype, "native", {
        /**
         * Get native.
         */
        get: function () {
            var windowAny = window;
            return windowAny.WebViewJavascriptBridge;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * On.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    XLMacNativeCore.prototype.on = function (type, listener) {
        this.native.addEventListener(type, function (event) {
            if (typeof listener === 'function') {
                listener(event);
            }
        });
        return this;
    };
    /**
     * Off.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    XLMacNativeCore.prototype.off = function (type, listener) {
        return this;
    };
    /**
     * Check if support CheckFunction.
     * @return {boolean}
     */
    XLMacNativeCore.prototype.supportCheckFuncion = function () {
        return typeof this.native.checkFunction === 'function';
    };
    /**
     * Check function.
     * @param {string} functionName
     * @return {Promise<NativeCoreCheckFunctionResponse>}
     */
    XLMacNativeCore.prototype.checkFunction = function (functionName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.supportCheckFuncion() && _this.native.checkFunction) {
                _this.native.checkFunction(functionName, function (response) {
                    resolve({
                        exist: response && response.exist,
                    });
                });
            }
            else {
                var naError = {
                    error: sdk_1.ErrorType.NOT_FOUND,
                };
                reject(naError);
            }
        });
    };
    /**
     * Call.
     * @param {string} functionName
     * @param {any[]} args
     * @return {Promise<T>}
     */
    XLMacNativeCore.prototype.call = function (functionName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            var _a;
            (_a = _this.native).callHandler.apply(_a, __spreadArrays([functionName], args, [function (error, returnValue) {
                    var nativeApiError = _this._toNAError(error);
                    if (nativeApiError) {
                        reject(nativeApiError);
                    }
                    else {
                        resolve(returnValue);
                    }
                }]));
        });
    };
    /**
     * To native error.
     * @param {any} error
     * @return {ResponseError | null}
     */
    XLMacNativeCore.prototype._toNAError = function (error) {
        var naError = null;
        if (error) {
            naError = {
                error: sdk_1.ErrorType.UNKNOWN,
            };
            if (error.code == -999) {
                naError.error = sdk_1.ErrorType.NOT_FOUND;
            }
            else {
                naError.error = sdk_1.ErrorType.UNKNOWN;
            }
            naError.error_description = error.message;
            naError.details = error;
        }
        return naError;
    };
    return XLMacNativeCore;
}());
exports.XLMacNativeCore = XLMacNativeCore;
/**
 * XL mac native api.
 */
var XLMacNativeApi = /** @class */ (function (_super) {
    __extends(XLMacNativeApi, _super);
    /**
     * constructor.
     */
    function XLMacNativeApi() {
        var _this = _super.call(this) || this;
        _this._nativeCore = new XLMacNativeCore();
        return _this;
    }
    Object.defineProperty(XLMacNativeApi.prototype, "nativeCore", {
        /**
         * Get native core.
         */
        get: function () {
            return this._nativeCore;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Init.
     */
    XLMacNativeApi.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.nativeCore.on('userChange', function (event) {
                    if (event) {
                        switch (event.state) {
                            case 0:
                                _this.emit('logout');
                                break;
                            case 2:
                                _this.emit('login');
                                break;
                            case 3:
                                // loginFail
                                break;
                            default:
                                break;
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get app info.
     */
    XLMacNativeApi.prototype.getAppInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appInfo, runTask1, runTask2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appInfo = {};
                        runTask1 = function () { return __awaiter(_this, void 0, void 0, function () {
                            var userInfo, preStr, index, deviceId, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this._callGetUserInfo()];
                                    case 1:
                                        userInfo = _a.sent();
                                        if (userInfo) {
                                            if (userInfo.appId !== undefined && userInfo.appId !== null) {
                                                appInfo.appId = userInfo.appId;
                                            }
                                            if (userInfo.appName !== undefined && userInfo.appName !== null) {
                                                if (typeof userInfo.appName === 'string') {
                                                    preStr = 'PC-';
                                                    index = userInfo.appName.indexOf(preStr);
                                                    if (index === 0) {
                                                        appInfo.noHostAppName = userInfo.appName.substr(preStr.length);
                                                    }
                                                }
                                                appInfo.appName = userInfo.appName;
                                            }
                                            if (userInfo.deviceSign !== undefined &&
                                                userInfo.deviceSign !== null) {
                                                appInfo.deviceSign = userInfo.deviceSign;
                                            }
                                            deviceId = utils_1.deviceSign2DeviceId(appInfo.deviceSign);
                                            if (deviceId) {
                                                appInfo.deviceId = deviceId;
                                            }
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_1 = _a.sent();
                                        console.error(error_1);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        runTask2 = function () { return __awaiter(_this, void 0, void 0, function () {
                            var platformInfo, error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.nativeCore.call('getPlatformInfo')];
                                    case 1:
                                        platformInfo = _a.sent();
                                        if (platformInfo &&
                                            typeof platformInfo.peerId === 'string' &&
                                            platformInfo.peerId.length > 0) {
                                            appInfo.peerId = platformInfo.peerId;
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_2 = _a.sent();
                                        console.error(error_2);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        return [4 /*yield*/, Promise.all([runTask1(), runTask2()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, appInfo];
                }
            });
        });
    };
    /**
     * Get session user info.
     */
    XLMacNativeApi.prototype.getSessionUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var macUserInfo, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._callGetUserInfo()];
                    case 1:
                        macUserInfo = _a.sent();
                        result = {};
                        if (macUserInfo) {
                            if (macUserInfo.userId !== undefined) {
                                result.userId = macUserInfo.userId;
                            }
                            if (macUserInfo.sessionId !== undefined) {
                                result.sessionId = macUserInfo.sessionId;
                            }
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Set login info.
     * @param {LoginInfo} loginInfo
     */
    XLMacNativeApi.prototype.setLoginInfo = function (loginInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nativeCore.call('setLoginInfo', loginInfo)];
            });
        });
    };
    /**
     * Show login window.
     */
    XLMacNativeApi.prototype.showLoginWindow = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nativeCore.call('showLoginWindow')];
            });
        });
    };
    /**
     * Get user info.
     */
    XLMacNativeApi.prototype._callGetUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nativeCore.call('getUserInfo')];
            });
        });
    };
    return XLMacNativeApi;
}(interface_1.NativeApi));
exports.XLMacNativeApi = XLMacNativeApi;
//# sourceMappingURL=xl-mac-native-api.js.map